export const PICS = [
{
    path: 'res/p1/ccdt.png',
},

{
    path: 'res/p3/ccyjsbg.jpg',
},
{
    path: 'res/p3/fj-1.png',
},
{
    path: 'res/p3/hg-1.png',
},


{
    path: 'res/p4/bg.jpg',
},
{
    path: 'res/p4/1.qijs.png',
},
{
    path: 'res/p4/2.zzjd.png',
},
{
    path: 'res/p4/3.ppln.png',
},
{
    path: 'res/p4/4.ppry.png',
},
{
    path: 'res/p4/5.zzmj.png',
},


{
    path: 'res/video/1sq.jpg',
},{
    path: 'res/video/2rn.jpg',
},{
    path: 'res/video/4hg.jpg',
}];